import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { get, orderBy, groupBy } from 'lodash'
import queryString from 'query-string'

import history from '@source/history'
import { getCookie } from '@source/lib/globalUtil'
import { logoHeaderDektop, logoMolaMobile, logoMolaText, logoMolaIcon, accountIcon } from '@global/imageUrl'
import LazyLoad from '@components/common/Lazyload'
import Link from '@components/Link'

import config from '@source/config'

import Badges from '@components/NotificationBadges'
import PopUpNotif from '@components/PopUpNotification'

import { getCounterInbox } from '@actions/inbox'
import { placeholderBlank } from '@global/imageUrl'
import s from './SideHeader.css'

class SideHeader extends Component {
  state = {
    notification: {
      isShowNotif: false,
      notifLink: '',
      notifText: '',
      notifData: null,
      videoId: '',
    },
    run: false,
    navBackground: 'transparent',
  }

  selectedSidebar = window.location.pathname === '/' ? '/' : window.location.href

  async subscribeNotif(checkInterval, showTime, upcText, ongoingText, querySize) {
    // const showTime = 600 //10menit = 6000 detik
    const query = querySize ? '?size=' + querySize : ''
    let response = await fetch('/api/v2/games/quiz/shows' + query)
    // let response = await fetch('/quiz_aug.json' + query)
    // let response = await fetch("https://private-a29123-quizmola.apiary-mock.com/quiz" + query)
    let debugError
    if (response.status == 502) {
      // Status 502 is a connection timeout error,
      // may happen when the connection was pending for too long,
      // and the remote server or a proxy closed it
      // let's reconnect
      await new Promise(resolve => setTimeout(resolve, checkInterval))
      await this.subscribeNotif(checkInterval, showTime, upcText, ongoingText, querySize)
    } else {
      let result = ''
      if (response.status != 200) {
        // An error - let's show it
        result = response.statusText
        window.notifResponse = response
        debugError = response.statusText
      } else {
        result = await response.text()
        const resultObj = JSON.parse(result)
        const resultData = get(resultObj, 'data', [])
        const orderedResult = orderBy(resultData, 'attributes.startedAt', 'asc')
        let notificationData, upcomingData, timeoutInterval, debugState
        // console.log("orderedResult", orderedResult)
        orderedResult.map(res => {
          const now = new Date()
          const currentTimestamp = now.getTime()
          const state = get(res, 'attributes.state', 0),
            startedAt = new Date(get(res, 'attributes.startedAt', null))

          if ((state == 1 || state == 2) && startedAt) {
            //jika status == upcoming atau ongoing
            // console.log("cal:", startedAt.getTime(), currentTimestamp, startedAt.getTime() - currentTimestamp, showTime)
            const duration = startedAt.getTime() - currentTimestamp
            // console.log("Res", res, "duration", duration)
            if (state == 2 && duration <= showTime && !notificationData) {
              //jika jeda waktu sekarang ke upcoming quiz <= param showtime
              //showtime artinya notif akan muncul x detik sebelum waktu quiz mulai
              //misal showTIme = 60000 (dalam detik )
              notificationData = { ...res, duration }
            } else if (!upcomingData && duration > 0) {
              upcomingData = { ...res, duration }
            }
          }
        })

        // console.log("notificationData", notificationData)
        // console.log("upcomingData", upcomingData)

        if (notificationData) {
          const state = get(notificationData, 'attributes.state', 0)
          const notifDisplayedId = getCookie('ntf') //get(this.state.notification, 'notifData.id', null)
          //notif yang akan muncul adalah notif yang sudah muncul sebelumnya dan sedang di close user
          const isNotifClosed = notifDisplayedId == notificationData.id && !this.state.notification.isShowNotif
          // console.log("apa ini", notificationData.duration)
          if (state === 1 && notificationData.duration > 0) {
            //upcoming dan dalam rentang waktu muncul notif (showtime)
            debugState = 1
            this.setState({
              notification: {
                isShowNotif: isNotifClosed ? false : true,
                // notifLink: '/watch?v=' + get(notificationData, 'attributes.videoID', ''),
                notifText: upcText,
                notifData: { ...notificationData },
                videoId: get(notificationData, 'attributes.videoID', ''),
                duration: notificationData.duration,
              },
            })
            // console.log("XXX")

            timeoutInterval = notificationData.duration
          } else {
            debugState = 2
            //ongoing sedang live
            this.setState({
              notification: {
                isShowNotif: isNotifClosed ? false : true,
                // notifLink: '/watch?v=' + get(notificationData, 'attributes.videoID', '/'),
                notifText: ongoingText,
                notifData: { ...notificationData },
                videoId: get(notificationData, 'attributes.videoID', ''),
                duration: 0,
              },
            })
            // console.log("kesini kaliii")
            timeoutInterval = checkInterval
          }
        } else if (upcomingData) {
          debugState = 3
          document.cookie = 'ntf=0; max-age=-1; path=/;'
          //upcoming masih lama
          const nextCall = get(upcomingData, 'duration', 0)
          // console.log("nextCall", nextCall, showTime)
          const intervalToShow = nextCall - showTime
          if (nextCall && nextCall > 0) {
            //interval between upcoming time and 10 min before upcoming
            timeoutInterval = intervalToShow > 0 ? intervalToShow : nextCall
          } else {
            timeoutInterval = checkInterval
          }
          this.setState({
            notification: {
              isShowNotif: intervalToShow < 0,
              notifText: intervalToShow < 0 ? upcText : '',
              notifData: intervalToShow < 0 ? { ...upcomingData } : null,
              videoId: get(upcomingData, 'attributes.videoID', ''),
              duration: nextCall,
            },
          })
          // console.log("BBB", timeoutInterval)
        } else {
          this.setState({
            notification: {
              isShowNotif: false,
              notifText: '',
              notifData: null,
              duration: 0,
            },
          })
          document.cookie = 'ntf=0; max-age=-1; path=/;'
          timeoutInterval = checkInterval
        }
        window.debugNotif = {
          notificationData,
          upcomingData,
          state: { ...this.state.notification },
          timeoutInterval,
          debugState,
          debugError,
          querySize,
        }
        // console.log("timeoutInterval", timeoutInterval)
        await new Promise(resolve => setTimeout(resolve, timeoutInterval))
        await this.subscribeNotif(checkInterval, showTime, upcText, ongoingText, querySize)
      }
      window.debugNotif = {
        debugError,
        querySize,
      }
    }
  }

  componentDidMount() {
    const {
      configParams,
      runtime: { isMobile },
      user: { token, uid = '', sid = '' },
    } = this.props

    const isLogin = uid || sid

    this.selectedSidebar = window.location.pathname === '/' ? '/' : window.location.href

    if (isLogin) {
      const counter_enabled = get(configParams, 'data.inbox_counter_enabled', false)
      if (counter_enabled) {
        this.props.getCounterInbox()
        this.intervalCounterInbox = setInterval(() => {
          this.props.getCounterInbox()
        }, 60000)
      }
    }

    const notificationBar = get(configParams, 'data.notification_bar', null)
    const notifEnable = isMobile
      ? get(notificationBar, 'enable_mobile', false)
      : get(notificationBar, 'enable_desktop', false)
    if (notifEnable) {
      //check_interval in second
      const checkInterval = get(notificationBar, 'check_interval', 60) * 1000,
        showTime = get(notificationBar, 'show_before_time', 0) * 1000,
        upcText = get(notificationBar, 'upcoming_text', ''),
        ongoingText = get(notificationBar, 'ongoing_text', ''),
        querySize = get(notificationBar, 'query_size', '')
      this.subscribeNotif(checkInterval, showTime, upcText, ongoingText, querySize)
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalCounterInbox)
  }

  handleIconClick = to => {
    history.push(to)
  }

  handleSidebarClick = to => {
    this.selectedSidebar = to === '/' ? '/' : to
    history.push(to)
  }

  handleButtonBack = () => {
    if (this.props.onBackButtonPress) {
      this.props.onBackButtonPress();
      return;
    }

    history.goBack()
  }

  handleScrollChildren = () => {
    let scrollEl = window.document.getElementsByClassName('children__container ')
    scrollEl[0].addEventListener('scroll', () => {
      if (scrollEl[0].scrollTop > 50) {
        this.setState({ navBackground: 'rgba(0, 0, 0, 0.85)' })
      } else {
        this.setState({ navBackground: 'transparent' })
      }
    })
  }

  renderCleanLayout = () => {
    return (
      <>
        <div className={`${s.header__clean__container}`}>
          <div className={`${s.header__relative__container} ${s.header__logo_center}`}>
            <div className={s.left__float__container}>
              <div className={s.logo__mola__container} onClick={() => this.handleIconClick('/')}>
                <LazyLoad
                  src={logoHeaderDektop}
                  fallbackImageUri={`${placeholderBlank}?h=20`}
                  containerClassName={s.logo__mola}
                />{' '}
              </div>
            </div>
          </div>
        </div>
        <div className={s.children__grid__container} style={{ gridTemplateColumns: 'auto' }}>
          <div className={`${s.children__container} children__container`} style={{ overflowY: 'auto' }}>
            {this.props.children}
          </div>
        </div>
      </>
    )
  }

  handleClickNotif = (e, videoId) => {
    e.preventDefault()
    this.setState({
      notification: {
        isShowNotif: false,
      },
    })

    const notifDataId = get(this.state.notification, 'notifData.id', '')

    if (notifDataId) {
      document.cookie = `ntf=${notifDataId}; path=/;`
    }

    const {
      runtime: { isMobile },
      configParams,
    } = this.props
    if (isMobile) {
      this.setCSStyling(true)
    }

    if (videoId) {
      const redirectUrl = get(configParams, 'data.notification_bar.redirect_url_desktop', null)
      if (redirectUrl) {
        window.location.href = redirectUrl
      } else {
        window.location.href = `/watch?v=${videoId}`
      }
    }
  }

  componentDidUpdate() {
    // let pathname = window.location.pathname.split('/')[1]
    let href = window.location.pathname === '/' ? '/' : window.location.href
    if (this.selectedSidebar !== href) {
      this.selectedSidebar = href || '/'
    }
  }

  setCSStyling = (isClose = false) => {
    if (__BROWSER__) {
      setTimeout(function () {
        const helpButton = document.querySelector('.embeddedServiceHelpButton .helpButton')
        const menuScroll = document.getElementsByClassName('menu-scroll')
        if (helpButton && !isClose) {
          helpButton.style.top = '44px'

          if (menuScroll && menuScroll.length > 0) {
            menuScroll[0].style.top = '90px'
          }
        }
      }, 1000)

      const helpButton = document.querySelector('.embeddedServiceHelpButton .helpButton')
      const menuScroll = document.getElementsByClassName('menu-scroll')
      if (helpButton && isClose) {
        helpButton.style.top = '14px'
      }

      if (isClose) {
        if (menuScroll && menuScroll.length > 0) {
          menuScroll[0].style.top = '60px'
        }
      }
    }
  }

  handleClickNotifMobile = () => {
    const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent)

    const { videoId } = this.state.notification
    const domain = config.endpoints.domain
    let urlParams = queryString.parse(window.location.search)
    const source = urlParams.utm_source ? urlParams.utm_source : 'molatv'
    const medium = urlParams.utm_medium ? urlParams.utm_medium : 'banner-notif'
    const campaign = urlParams.utm_campaign ? urlParams.utm_campaign : ''

    const redirectUrl = get(configParams, 'data.notification_bar.redirect_url_mobile', null)
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      if (isApple) {
        document.location = `molaapp://games/quiz/show/${videoId}?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`
        setTimeout(function () {
          const url = `watch?v=${videoId}&utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`
          history.push(url)
        }, 250)
      } else {
        // console.log("android", domain, videoId, source, medium)
        const url = encodeURIComponent(
          `${domain}/watch?v=${videoId}&utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`,
        )
        document.location = `intent://games/quiz/show/${videoId}?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}/#Intent;scheme=molaapp;package=tv.mola.app;S.browser_fallback_url=${url};end`
      }
    }
  }

  render() {
    const {
      notification,
      navBackground,
      notification: { videoId, notifData, duration },
    } = this.state

    const {
      cleanLayout,
      showNotif,
      noHeaderLibrary,
      configParams,
      runtime: { isMobile, activeMenuId },
      user: { uid = '', sid = '' },
      inbox: { counter },
    } = this.props

    const isLogin = uid || sid
    const urlParams = queryString.parse(window.location.search)
    const backTopPageTitle = urlParams.btp ? urlParams.btp : false

    const count = get(counter, 'data.unread', 0)
    if (cleanLayout && !isMobile) {
      return this.renderCleanLayout()
    }
    const showDesktopNotif = get(configParams, 'data.notification_bar.enable_desktop', false)
    const showMobileNotif = get(configParams, 'data.notification_bar.enable_mobile', false)
    const showNotifBar = this.state.notification.isShowNotif && showNotif
    const enterTextNotif = get(configParams, 'data.notification_bar.enter_text', false)
    const closeTextNotif = get(configParams, 'data.notification_bar.close_text', false)
    const headerMenu = get(configParams, 'quickAccess.header_menu', [])
    const sidebarMenu = get(configParams, 'quickAccess.sidebar_menu', [])
    const sidebarExclude = get(configParams, 'quickAccess.sidebar_exclude_menu', [])
    const footerList = get(configParams, 'quickAccess.footer.more', [])
    const notifRemainingMins = duration > 60000 ? Math.round(duration / 60000) : 1
    const urlParamTab = urlParams.tab || ''
    const accName = get(configParams, 'quickAccess.sidebar_account_menu', { title: 'Accounts', imageUrl: accountIcon })
    return (
      <>
        {/* header desktop */}
        {!isMobile && (
          <>
            {/* header */}
            {showNotifBar && showDesktopNotif && (
              <>
                <PopUpNotif
                  title={notification.notifText}
                  desc={duration > 0 ? `${notifRemainingMins}m to go` : 'Live now'}
                  handleClickNotif={this.handleClickNotif}
                  handleClickNotifMobile={this.handleClickNotifMobile}
                  enterText={enterTextNotif}
                  closeText={closeTextNotif}
                  videoId={videoId}
                />
                {/* <div className={`${s.notif_popup__container}`}>
                  <div className={s.notif_popup__icon}> <span><i /></span></div>
                  <div className={s.notif_popup__content}>
                    <div>{notification.notifText}</div>
                    <div className={s.notif_popup__desc}>{duration > 0 ? `${notifRemainingMins}m to go` : 'Live now'}</div>
                  </div>
                  <div className={s.notif_popup__action}>
                    <div className={s.notif_popup__action_wrapper}>
                      <a onClick={e => this.handleClickNotif(e, videoId)}>
                        Join
                      </a>
                      <a className={s.notif_popup__close} onClick={e => this.handleClickNotif(e)}>
                        Close
                      </a>
                    </div>
                  </div>
                </div> */}
              </>
            )}
            {!noHeaderLibrary && (
              <div className={`${s.header__container}`}>
                <div className={s.sidebar__margin} />
                {headerMenu.length > 0 && (
                  <div className={s.library__relative__container}>
                    <div
                      className={`${s.library__container} children__header`}
                      style={{ backgroundColor: navBackground }}
                    >
                      {headerMenu.map(hmi => (
                        <div
                          key={hmi.id}
                          className={
                            activeMenuId === hmi.id ? `${s.library__item} ${s.library__item__active}` : s.library__item
                          }
                          onClick={() => this.handleIconClick(hmi.url)}
                        >
                          {hmi.title}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* alwaysShowSidebar */}
            {sidebarMenu.length > 0 ? (
              <div className={`${s.children__grid__container}`}>
                {/* sidebar */}
                <div className={`${s.children__sidebar} children__sidebar`}>
                  <div className={s.sidebar__expand}>
                    <div className={s.logo__container}>
                      <img
                        src={logoMolaIcon}
                        alt="logo Mola"
                        className={s.logoMolaIcon}
                        onClick={() => this.handleSidebarClick('/')}
                      />
                    </div>
                    <div className={s.logo__horizontal__container}>
                      <img
                        src={logoMolaText}
                        alt="logo Mola"
                        className={s.logo__horizontal}
                        onClick={() => this.handleSidebarClick('/')}
                      />
                    </div>
                    <div className={s.account__container} onClick={() => this.handleSidebarClick('/accounts/profile')}>
                      <div className={s.account__item__container}>
                        <div
                          className={
                            sidebarExclude.indexOf(urlParamTab) < 0
                              ? this.selectedSidebar.indexOf('accounts/profile') > 0
                                ? s.selected__sidebar__item
                                : null
                              : null
                          }
                        />
                        <img src={accName.imageUrl} className={s.account__icon} />
                        <div
                          className={
                            sidebarExclude.indexOf(urlParamTab) < 0
                              ? this.selectedSidebar.indexOf('accounts/profile') > 0
                                ? `${s.sidebar__item__text} ${s.selected__item__text}`
                                : s.sidebar__item__text
                              : s.sidebar__item__text
                          }
                        >
                          {accName.title}
                        </div>
                      </div>
                      {count > 0 && (
                        <div className={`${s.badges_wrap} ${count > 99 ? s.badges_large : ''}`}>
                          <Badges count={count} />
                        </div>
                      )}
                    </div>
                    <div className={s.sidebar__item__container}>
                      {sidebarMenu.map(sbi => (
                        <div
                          className={s.item__image__container}
                          key={sbi.title}
                          onClick={() => this.handleSidebarClick(sbi.url)}
                        >
                          <div
                            className={
                              this.selectedSidebar === sbi.url
                                ? s.selected__sidebar__item
                                : sbi.url !== '/' && this.selectedSidebar.indexOf(sbi.url) >= 0
                                  ? s.selected__sidebar__item
                                  : null
                            }
                          />
                          <img src={sbi.imageUrl} className={s.sidebar__item__image} />
                          <div
                            className={
                              this.selectedSidebar === sbi.url
                                ? `${s.sidebar__item__text} ${s.selected__item__text}`
                                : sbi.url !== '/' && this.selectedSidebar.indexOf(sbi.url) >= 0
                                  ? `${s.sidebar__item__text} ${s.selected__item__text}`
                                  : s.sidebar__item__text
                            }
                          >
                            {sbi.title}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* children */}
                </div>
                <div className={`${s.children__container} children__container`} onScroll={this.handleScrollChildren}>
                  {this.props.children}
                </div>
              </div>
            ) : (
                <>{this.props.children}</>
              )}
          </>
        )}

        {/* header mobile */}
        {isMobile && (
          <>
            {showNotifBar && showMobileNotif && (
              <>
                {this.setCSStyling()}
                <div className={s.notif__offset}></div>
                <div className={`${s.notif__container} notif-container`}>
                  <a onClick={e => this.handleClickNotif(e, videoId)}>
                    <span>{notification.notifText}</span>
                  </a>
                  <i onClick={e => this.handleClickNotif(e)} />
                </div>
              </>
            )}
            <div className={`${s.header__mobile__container} ${showNotifBar ? s.header_w_notif : ''}`}>
              {backTopPageTitle ? (
                <div className={s.title__container__mobile}>
                  <div className={s.backIcon} onClick={this.handleButtonBack} />
                  <div className={s.title__mobile}> {backTopPageTitle} </div>
                </div>
              ) : (
                  <Link to="/" className={s.link__container__mobile}>
                    {/* <LazyLoad alt="molatv" src={logoHorizontal} className={s.logo__mola__mobile} containerClassName={s.logo_container__mobile} /> */}
                    <img alt="molatv" src={logoMolaMobile} className={s.logo__mola__mobile} />
                  </Link>
                )}
            </div>
            {this.props.children}
          </>
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return { ...state }
}
const mapDispatchToProps = dispatch => ({
  getCounterInbox: () => dispatch(getCounterInbox()),
})

export default compose(withStyles(s), connect(mapStateToProps, mapDispatchToProps))(SideHeader)
